import React, {Component} from "react";
import {Container} from "react-bootstrap";
import {Route, Switch, withRouter} from 'react-router-dom';
import Home from './pages/Home';
import LoginCallback from './components/LoginCallback';
import Pages from './pages/Pages';
import Page from './pages/Page';
import CreateOrganisation from './pages/CreateOrganisation';
import Banding from "./pages/Banding";
import Privacy from "./pages/Privacy";
import Tos from "./pages/Tos";
import HowTo from "./pages/HowTo";
import Videos from "./pages/Videos";
import Help from "./pages/Help";
import Header from "./components/Header";
import AppHeader from "./app-shell/AppHeader";
import Login from "./components/Login";
import Logout from "./components/Logout";
import About from "./pages/About";
import Admin from "./pages/Admin";
import Contact from "./pages/Contact";
import './lib/axiosCommon'
import Organisation from "./pages/Organisation";

// Redesigned marketing pages render their own header/footer and need to sit
// outside the app's Bootstrap Container (which adds side padding that breaks
// their edge-to-edge sections). Everything else keeps the existing app shell.
const MARKETING_PATHS = ['/', '/howto', '/contact'];

class App extends Component {
    constructor(props) {
        super(props);
        const authentication = JSON.parse(sessionStorage.getItem('authentication'))
        this.state = {
            authentication: authentication,
        };
    }

    onSignIn = (idToken, features, organisation) => {
        const authentication = {
            email: idToken.email,
            name: idToken.name,
            sub: idToken.sub,
            features,
            organisation
        }
        this.setState({authentication: authentication});
        sessionStorage.setItem('authentication', JSON.stringify(authentication));
    }
    
    onOrgCreate = (organisation) => {
        const authentication = {
            ...this.state.authentication,
            organisation
        }
        this.setState({authentication: authentication});
        sessionStorage.setItem('authentication', JSON.stringify(authentication));
    }

    render() {
        const pathname = this.props.location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
        const isMarketingPath = MARKETING_PATHS.includes(pathname);
        // /pages/:pageId (including /pages/new) renders its own app bar (see
        // AppBar.js) and must sit outside the old marketing Header, same as
        // the marketing pages above.
        const isPageEditorPath = /^\/pages\/[^/]+$/i.test(pathname);
        // My pages, Organisation and Create Organisation are redesigned and
        // share AppHeader (which AppBar's breadcrumb links back to) instead
        // of the old marketing Header.
        const isAppBrowsePath = pathname === '/pages' || pathname === '/createorganisation'
            || pathname === '/videos' || pathname === '/help' || /^\/organisations\/[^/]+$/i.test(pathname);
        // Sign-in/out are momentary redirect stubs (they render a line of
        // text, then immediately bounce to Cognito's hosted UI), and the
        // OAuth callback is a transient state before there's a session -
        // none of them should flash the old header for that instant.
        const isAuthRedirectPath = pathname === '/logincallback' || pathname === '/login' || pathname === '/logout';

        if (isMarketingPath) {
            return (
                <Switch>
                    <Route exact path="/">
                        <Home authentication={this.state.authentication}/>
                    </Route>
                    <Route path="/HowTo" component={HowTo}/>
                    <Route path="/contact" component={Contact}/>
                </Switch>
            );
        }

        if (isPageEditorPath) {
            return (
                <Route exact path="/pages/:pageId" render={(props) => (
                    <Page {...props} authentication={this.state.authentication} key={props.match.params.pageId || 'empty'}/>
                )}/>
            );
        }

        if (isAuthRedirectPath) {
            return (
                <Switch>
                    <Route path="/logincallback">
                        <LoginCallback authentication={this.state.authentication} onSignIn={this.onSignIn}/>
                    </Route>
                    <Route path="/login">
                        <Login/>
                    </Route>
                    <Route path="/logout">
                        <Logout/>
                    </Route>
                </Switch>
            );
        }

        if (isAppBrowsePath) {
            return (
                <div>
                    <AppHeader authentication={this.state.authentication}/>
                    <Switch>
                        <Route exact path="/pages">
                            <Pages authentication={this.state.authentication}/>
                        </Route>
                        <Route exact path="/createOrganisation" render={(props) => (
                            <CreateOrganisation {...props} authentication={this.state.authentication} onOrgCreate={this.onOrgCreate}/>
                        )}/>
                        <Route exact path="/organisations/:orgId" render={(props) => (
                            <Organisation {...props} authentication={this.state.authentication} key={props.match.params.orgId || 'empty'}/>
                        )}/>
                        <Route exact path="/Videos">
                            <Videos/>
                        </Route>
                        <Route exact path="/Help">
                            <Help/>
                        </Route>
                    </Switch>
                </div>
            );
        }

        return (
            <Container fluid>
                <Header
                    authentication={this.state.authentication}/>
                <main>
                    <Switch>
                    <Route exact path="/admin">
                        <Admin authentication={this.state.authentication}/>
                    </Route>
                    <Route path="/Banding" component={Banding}/>
                    <Route path="/privacy" component={Privacy}/>
                    <Route path="/tos" component={Tos}/>
                    <Route path="/about" component={About}/>
                    </Switch>
                </main>
            </Container>
        );
    }
}

export default withRouter(App);
